import { render, staticRenderFns } from "./card-item.vue?vue&type=template&id=2a1af67f&scoped=true&"
import script from "./card-item.vue?vue&type=script&lang=js&"
export * from "./card-item.vue?vue&type=script&lang=js&"
import style0 from "./card-item.vue?vue&type=style&index=0&id=2a1af67f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1af67f",
  null
  
)

export default component.exports